import React from 'react';
import ReactDOM from 'react-dom';

import './index.module.less';

import FridayService from '@services/friday';
import { isCubeApp, commandMessage } from '@helpers/Constants';
import NativeInterface from '@helpers/NativeInterface';

import { Confirm } from '../ConfirmModal';

interface IProps {
  onConfirm?: () => void;
}

const contentDesc = [
  {
    desc: '请检查：',
  },
  {
    desc: '1、设备是否已开机',
  },
  {
    desc: '2、设备是否有电',
  },
  {
    desc: '3、设备是否欠费',
  },
  {
    desc: '4、设备是否开通流量',
  },
  {
    desc: '5、设备是否插入SIM卡',
  },
];

const promptContainer = document.getElementById('modal');
export const OfflineHelp = (props: IProps) => {
  const toDetail = async () => {
    FridayService.addEvent(
      'device_offline_view_other_offline_reasons_click',
    );
    const url = 'https://help.seewo.com/square/dEcRv5QFBb';
    if (isCubeApp()) {
      //在app环境中 跳转到外部小页面时需要打开新的webview容器
      NativeInterface.postMessage(commandMessage.openNewContainer, { url });
    } else {
      window.location.assign(url);
    }
  };

  const confirm = () => {
    close();
    props.onConfirm && props.onConfirm();
  };

  const close = () => {
    ReactDOM.unmountComponentAtNode(promptContainer as HTMLElement);
  };

  const cancel = () => {
    close();
  };

  return (
    <>
      <Confirm
        title="设备已离线"
        // confirmTheme="normal"
        onConfirm={confirm}
        onCancel={cancel}
        ContentWidget={
          <>
            <div styleName="content">
              {contentDesc.map(item => {
                return <div styleName="desc">{item.desc}</div>;
              })}
              <div styleName="tip" onClick={toDetail}>
                {'都不是？查看其他离线原因>'}
              </div>
            </div>
          </>
        }
      />
    </>
  );
};

const ExportedOfflineHelp = {
  show() {
    ReactDOM.render(<OfflineHelp />, promptContainer);
  },
};

export default ExportedOfflineHelp;
